import { Link } from "react-router-dom";
import "../styles/navbar.css";

function Brand() {
  return (
    <span className="ix-wordmark">
      in<span className="r">tel</span>lus<span className="g">ion</span>
    </span>
  );
}

function Navbar() {
  const closeMenu = () => {
    const nav = document.getElementById("navbarNav");
    if (nav && nav.classList.contains("show")) {
      const toggler = document.querySelector(".navbar-toggler");
      if (toggler) toggler.click();
    }
  };

  return (
    <nav className="navbar navbar-expand-lg ix-navbar fixed-top">
      <div className="ix-shell ix-navbar-in">
        <Link className="navbar-brand ix-brand" to="/" onClick={closeMenu}>
          <Brand />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="ix-toggler-bar" />
          <span className="ix-toggler-bar" />
        </button>

        <div className="collapse navbar-collapse ix-navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ix-nav-links">
            <li className="nav-item"><Link to="/projects" onClick={closeMenu}>Products</Link></li>
            <li className="nav-item"><Link to="/about" onClick={closeMenu}>Mission</Link></li>
            <li className="nav-item"><Link to="/ilab" onClick={closeMenu}>iLab</Link></li>
            <li className="nav-item"><Link to="/bill-y" onClick={closeMenu}>Bill-y</Link></li>
            <li className="nav-item ix-nav-cta-item">
              <Link className="ix-nav-cta" to="/contact" onClick={closeMenu}>Contact</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
